export default __webpack_public_path__ + "static/media/pdfIconRed.b672bc69.svg";